/**
 * Единый префикс HTTP к биллингу на том же origin, что и SPA (мост через `server.js` → Billing CORE / wallet).
 * Согласован с **`markbaseCORE/_shared/frontend/billingApiPaths.js`** и **`markbase.ru/modouls/_shared/frontend/billingApiPaths.ts`** (**T-R3**, **CORE_tariffs_ETALON** §9).
 * Новые вызовы к `/api/billing/*` в монолите — через **`billingApiPath`**, не литералами.
 */
export const BILLING_HTTP_PREFIX = '/api/billing';

export const SETTINGS_HTTP_PREFIX = '/api/settings';

/** @param {string} rest без ведущего `/`, напр. `tariffs` или `admin/tariffs` */
export function billingApiPath(rest) {
  const r = String(rest || '').replace(/^\/+/, '');
  return r ? `${BILLING_HTTP_PREFIX}/${r}` : BILLING_HTTP_PREFIX;
}

/** @param {string} rest без ведущего `/` */
export function settingsApiPath(rest) {
  const r = String(rest || '').replace(/^\/+/, '');
  return r ? `${SETTINGS_HTTP_PREFIX}/${r}` : SETTINGS_HTTP_PREFIX;
}
